import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

let fullCalendarInstance = null;
let selectedDate = new Date();

window.modalCalendar = {
    getInstance: () => fullCalendarInstance,
    refreshLayout: () => {
        if (fullCalendarInstance) {
            fullCalendarInstance.updateSize();
            fullCalendarInstance.render();
        }
    },
    gotoDate: (date) => {
        if (fullCalendarInstance) {
            selectedDate = new Date(date);
            fullCalendarInstance.gotoDate(date);
            highlightSelectedDate(selectedDate);
            updateSelectedDateDisplay();
        }
    },
    getSelectedDate: () => selectedDate,
    syncToMainCalendar: () => {
        // Sync selected date back to main calendar
        if (window.mainCalendarInstance && selectedDate) {
            window.mainCalendarInstance.setOption('date', selectedDate);
        }
    }
};

function initFullCalendar(containerId = 'modal-full-calendar', initialDate = null) {
    const container = document.getElementById(containerId);
    if (!container) return null;

    if (fullCalendarInstance) {
        fullCalendarInstance.destroy();
        fullCalendarInstance = null;
    }

    selectedDate = initialDate || selectedDate;

    fullCalendarInstance = new Calendar(container, {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        initialDate: selectedDate,
        headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: ''
        },
        height: 'auto',
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        buttonText: {
            today: 'Today',
        },
        dateClick: function(info) {
            selectedDate = new Date(info.dateStr);

            // Auto navigate to the correct month if clicking on next month dates
            const currentViewDate = fullCalendarInstance.getDate();
            const clickedDate = new Date(info.dateStr);

            if (clickedDate.getMonth() !== currentViewDate.getMonth() ||
                clickedDate.getFullYear() !== currentViewDate.getFullYear()) {
                fullCalendarInstance.gotoDate(clickedDate);
            }

            highlightSelectedDate(selectedDate);
            updateSelectedDateDisplay();
        },
        datesSet: function(info) {
            addTitleDropdown(info);
            highlightSelectedDate(selectedDate);
        }
    });

    fullCalendarInstance.render();
    setupIntervalButtons();
    highlightSelectedDate(selectedDate);
    updateSelectedDateDisplay();

    return fullCalendarInstance;
}

function updateSelectedDateDisplay() {
    const display = document.getElementById('selected-date-display');
    if (display && selectedDate) {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        display.textContent = `Selected: ${selectedDate.toLocaleDateString('en-US', options)}`;
    }
}

function addTitleDropdown(info) {
    if (!fullCalendarInstance) return;

    const titleContainer = fullCalendarInstance.el.querySelector('.fc-toolbar-title');
    if (titleContainer) {
        if (titleContainer.closest('.custom-title-wrapper')) return;

        titleContainer.style.cursor = 'pointer';

        const formattedDate = fullCalendarInstance.formatDate(info.start, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        const year = new Date(info.start).getFullYear();

        const dropdownHTML = `
        <div id="appt-month-year-picker-dropdown" class="custom-title-wrapper dropdown" data-dropdown="true" data-dropdown-trigger="click" data-dropdown-permanent="true">
          <div class="dropdown-toggle cursor-pointer">
            ${formattedDate}
          </div>
           <div class="dropdown-content w-full max-w-56">
          <div class="p-1 text-sm text-gray-900 font-medium">
           <div id="picker-header" class="flex justify-between items-center">
                <button id="picker-prev-btn" class="bg-transparent border-0 text-lg cursor-pointer p-2 hover:bg-gray-100 rounded w-8 h-8 flex items-center justify-center text-gray-600">&lt;</button>
                <h3 id="picker-title" class="m-0 cursor-pointer px-3 py-2 rounded transition-colors duration-200 hover:bg-gray-100 text-base font-medium flex-1 text-center">
                    ${year}
                </h3>
                <button id="picker-next-btn" class="bg-transparent border-0 text-lg cursor-pointer p-2 hover:bg-gray-100 rounded w-8 h-8 flex items-center justify-center text-gray-600">&gt;</button>
            </div>
          </div>
          <div class="border-b border-b-gray-200"></div>
          <div class="p-4">
            <div id="picker-content" class="mb-4 flex justify-center">
            </div>
          </div>
         </div>
        </div>
        </div>
      `;

        // Replace the plain title text with your custom dropdown
        const parent = titleContainer.parentElement;
        titleContainer.remove();
        parent.innerHTML = dropdownHTML;

        const dropdownEl = document.querySelector('#appt-month-year-picker-dropdown');
        const dropdown = KTDropdown.getInstance(dropdownEl);
        dropdown.on('show', () => {
            document.dispatchEvent(new CustomEvent('initMonthYearPicker'));
        });
    }
}

function setupIntervalButtons() {
    const intervalButtons = document.querySelectorAll('.interval-btn');

    intervalButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            const days = parseInt(this.getAttribute('data-interval'));
            if (!days || !fullCalendarInstance) return;

            const newDate = new Date(selectedDate);
            newDate.setDate(selectedDate.getDate() + days);
            selectedDate = newDate;
            fullCalendarInstance.gotoDate(newDate);
            highlightSelectedDate(newDate);
            updateSelectedDateDisplay();
        });
    });
}

function highlightSelectedDate(dateToHighlight) {
    if (!fullCalendarInstance || !dateToHighlight) return;

    setTimeout(() => {
        const dateStr = dateToHighlight.toISOString().split('T')[0];

        document.querySelectorAll('.fc-day').forEach(dayEl => {
            dayEl.classList.remove('selected-date');
        });

        const targetDayEl = document.querySelector(`[data-date="${dateStr}"]`);
        if (targetDayEl) {
            targetDayEl.classList.add('selected-date');
        }
    }, 50);
}

export { initFullCalendar, selectedDate };
